import styled from "styled-components";
import {logo_inline_w} from "../../constants/GlobalConst";

const themeBlue="var(--color-primary-strong)";
const navy="#20242b";

export const SignUpHeader = styled.header`
  display: flex;
  height: 72px;
  align-items: center;
  justify-content: center;
  background:
          radial-gradient(circle at 15% 20%, rgba(255,255,255,.14) 0 45px, transparent 46px),
          radial-gradient(circle at 82% 78%, rgba(255,255,255,.1) 0 150px, transparent 151px),
          linear-gradient(rgb(32, 36, 43) 0%, rgb(25, 28, 34) 100%);
  box-shadow: 0 3px 12px rgba(96, 54, 20, .12);
`;
export const Logo = styled.div`
  width: 174px;
  height: 42px;
  background-image: url(${logo_inline_w});
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
`;
export const BodyContainer = styled.main`
  min-height: calc(100vh - 72px);
  box-sizing: border-box;
  padding: 28px 24px 48px;
  background: #f5f6f8;

  @media (max-width: 640px) {
    padding: 22px 12px 36px;
  }
`;
export const StepContainer = styled.section`
  width: min(100%, 1080px);
  margin: 0 auto 18px;

  & > article {
    padding: 0;
  }

  & article > div h1 {
    margin: 0;
    color: #20242b;
    font-size: var(--font-size-26);
    font-weight: 800;
    letter-spacing: -.03em;
    text-align: center;
  }

  & article > div > p {
    margin: 7px 0 0;
    color: #7b838c;
    font-size: var(--font-size-13);
    line-height: 1.5;
    text-align: center;
  }
`;

export const Steps = styled.div`
  display: grid;
  grid-template-columns: 1fr 22px 1fr 22px 1fr;
  align-items: center;
  gap: 8px;
  margin: 24px 0 0;

  @media (max-width: 720px) {
    grid-template-columns: 1fr;
  }
`;
export const Step = styled.div`
  display: flex;
  min-width: 0;
  min-height: 66px;
  box-sizing: border-box;
  align-items: center;
  gap: 12px;
  padding: 10px 14px;
  border: 1px solid ${({$active}) => $active ? "#3b81f5" : "#e3e6e9"};
  border-radius: 10px;
  background: ${({$active}) => $active ? "#e6eefd" : "var(--color-surface)"};
  box-shadow: ${({$active}) => $active ? "0 5px 14px rgba(245,129,31,.08)" : "none"};

  & > div:first-child {
    width: 42px;
    height: 42px;
    flex: 0 0 42px;
    border-radius: 50%;
    border: 2px solid ${({$active}) => $active ? "#3b81f5" : "#e3e6e9"};
    background-color: var(--color-surface);
    background-repeat: no-repeat;
    background-position: center;
    background-size: 36px;
  }

  & > div:last-child {
    min-width: 0;
  }

  & > div:last-child h3 {
    margin: 0 0 4px;
    color: ${({$active}) => $active ? "#2562ea" : "#a1a7ad"};
    font-size: var(--font-size-11);
    font-weight: 800;
    letter-spacing: .08em;
  }

  & > div:last-child p {
    margin: 0;
    color: ${({$active}) => $active ? "#343b42" : "#8c939a"};
    font-size: var(--font-size-13);
    font-weight: 700;
    text-align: left;
  }
`;
export const Arrow = styled.div`
  width: 22px;
  height: 22px;
  background-image: url("/assets/images/join/icon_next.png");
  background-repeat: no-repeat;
  background-position: center;
  background-size: 8px auto;
  opacity: .45;

  @media (max-width: 720px) {
    display: none;
  }
`;

export const SignUpContents = styled.section`
  width: min(100%, 1080px);
  box-sizing: border-box;
  margin: 0 auto;
  padding: 26px 28px 30px;
  border: 1px solid var(--color-border);
  border-radius: 12px;
  background: var(--color-surface);
  box-shadow: 0 10px 30px rgba(31, 41, 55, .06);

  .done {
    display: flex;
    min-height: 390px;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }

  & article h2 {
    margin: 0 0 10px;
    color: #252b31;
    font-size: var(--font-size-18);
    font-weight: 800;
  }

  & article h3 {
    margin: 22px 0 9px;
    color: #41484f;
    font-size: var(--font-size-14);
  }

  @media (max-width: 640px) {
    padding: 22px 16px 26px;
  }
`;

export const TermsBox=styled.div`
  width:100%;height:220px;padding:18px;border:1px solid #e1e6eb;border-radius:8px;background:#fafbfc;color:#626c77;font-size: var(--font-size-12);line-height:1.7;
  overflow:auto;white-space:pre-wrap;&:focus-within{border-color:var(--color-primary-focus);}
`;
export const AlignRight=styled.div`
  display:flex;justify-content:flex-end;padding:14px 2px;color:#4f5964;font-size: var(--font-size-12);
  &:first-of-type{margin-top:18px;padding:14px 16px;border:1px solid #dbe7f5;border-radius:8px;background:#f5f9ff;color:#253345;font-weight:700;}
`;
export const ButtonGroup = styled.div`
  position: ${({$sticky}) => $sticky ? "sticky" : "relative"};
  bottom: ${({$sticky}) => $sticky ? "12px" : "auto"};
  z-index: ${({$sticky}) => $sticky ? "20" : "auto"};
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 9px;
  box-sizing: border-box;
  margin-top: 22px;
  padding: 16px 20px;
  border: 1px solid var(--color-divider);
  border-left: 4px solid var(--color-primary);
  border-radius: 10px;
  background: linear-gradient(90deg, #fff8f2 0%, rgba(255, 255, 255, .98) 48%);
  box-shadow: 0 -4px 20px rgba(245, 129, 31, .09);

  & button {
    min-width: 112px;
    height: 40px;
    box-sizing: border-box;
    padding: 0 18px;
    border-radius: 7px;
    font-family: inherit;
    font-size: var(--font-size-13);
    font-weight: 800;
    cursor: pointer;
    transition: background-color .15s ease, border-color .15s ease;
  }

  & button:first-child {
    border: 1px solid #dfe3e7;
    background: var(--color-surface);
    color: #666e76;
  }

  & button:first-child:hover {
    border-color: var(--color-primary);
    color: var(--color-main);
  }

  & button:last-child {
    margin-left: 0;
    color: var(--color-surface);
    border: 1px solid var(--color-primary);
    background: var(--color-primary);
    box-shadow: 0 5px 14px rgba(59, 130, 246, .2);
  }

  & button:last-child:hover {
    background: var(--color-primary-strong);
  }

  @media (max-width: 520px) {
    align-items: stretch;
    flex-direction: column-reverse;
    padding: 14px;

    & button {
      width: 100%;
    }
  }
`;

export const Form = styled.div`
  display: grid;
  width: 100%;
  box-sizing: border-box;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  align-items: start;
  gap: 16px;
  margin: 16px 0 0;
  padding: 0;
  border: 0;
  background: var(--color-surface);

  @media (max-width: 940px) {
    grid-template-columns: 1fr;
  }
`;

export const FormSection = styled.section`
  overflow: hidden;
  border: 1px solid var(--color-border);
  border-radius: 10px;
  background: var(--color-surface);
  box-shadow: 0 5px 16px rgba(31, 41, 55, .04);
`;

export const FormSectionHeader = styled.header`
  display: flex;
  min-height: 68px;
  box-sizing: border-box;
  align-items: center;
  padding: 15px 18px;
  border-bottom: 1px solid #eceff1;
  background: #fafbfc;
`;

export const FormSectionTitle = styled.h3`
  margin: 0 !important;
  color: #2d343b !important;
  font-size: var(--font-size-15) !important;
  font-weight: 800;
`;

export const FormSectionDescription = styled.p`
  margin: 5px 0 0;
  color: #858d95;
  font-size: var(--font-size-12);
  line-height: 1.45;
`;

export const FormSectionBody = styled.div`
  padding: 5px 18px 10px;

  & > div {
    position: relative;
    display: grid;
    min-height: 58px;
    box-sizing: border-box;
    grid-template-columns: 150px minmax(0, 1fr);
    align-items: center;
    gap: 14px;
    margin: 0;
    padding: 9px 0;
    border-bottom: 1px solid #f0f2f4;
    color: #444c54;
    font-size: var(--font-size-13);
  }

  & > div:last-child {
    border-bottom: 0;
  }

  & > div > div:first-child {
    width: auto;
    font-weight: 700;
  }

  & > div > div:last-child {
    display: flex;
    min-width: 0;
    align-items: center;
    gap: 8px;
  }

  & > div > div:last-child > * {
    margin-right: 0;
  }

  input[type='text'],
  input[type='password'],
  select {
    width: min(100%, 620px);
    min-width: 0 !important;
    height: 40px;
    box-sizing: border-box;
    padding: 0 12px;
    border: 1px solid #dfe3e7;
    border-radius: 7px;
    background: var(--color-surface);
    color: #30363d;
    font-family: inherit;
    font-size: var(--font-size-13);
    outline: 0;
  }

  input:focus,
  select:focus {
    border-color: #3b81f5;
    box-shadow: 0 0 0 3px rgba(245, 129, 31, .08);
  }

  input[readonly] {
    background: #f4f6f7;
    color: #747c84;
  }

  input[type='radio'] {
    accent-color: #3b81f5;
  }

  label {
    color: #555d65;
    font-size: var(--font-size-13);
  }

  @media (max-width: 720px) {
    & > div {
      grid-template-columns: 1fr;
      gap: 7px;
    }

    & > div > div:last-child {
      flex-wrap: wrap;
    }
  }

  @media (max-width: 640px) {
    padding-right: 14px;
    padding-left: 14px;
  }
`;
export const SignUpVerify=styled.button``;
export const AfterSignUpGuild=styled.div`
  display:flex;align-items:center;flex-direction:column;text-align:center;.tit{margin:24px 0 9px;color:#20242b;font-size: var(--font-size-22);font-weight:800;}.txt{color:#7e8791;font-size: var(--font-size-13);}
`;
export const Round=styled.div`
  position:relative;width:100px;height:100px;border:1px solid var(--color-primary-border);border-radius:50%;background:var(--color-primary-soft);
  &::before{position:absolute;top:25px;left:27px;width:43px;height:24px;border-left:7px solid ${themeBlue};border-bottom:7px solid ${themeBlue};content:"";transform:rotate(-45deg);}
`;
export const ValidationScript=styled.div`position:absolute!important;left:0;bottom:-12px;color:#e05252!important;font-size: var(--font-size-11)!important;`;
export const RequiredMark=styled.span`margin-left:3px;color:#e05252;font-size: var(--font-size-13);font-weight:700;`;
export const BodyContainerLegacy=BodyContainer;
